import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ErrorModal from '../../../components/errorModal';
import { API_ENDPOINT } from '../../../constants';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { formatPrice, getHumanReadablePaymentMethod, getHumanReadableStatus } from '../helper';
import { getTimeForPatient } from '../../referral/helper';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

class PreviewPayment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            }
        };


    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    setInitialData = () => {
        const paymentData = this.state.paymentData ?? null;
        const currency = paymentData?.amount?.currency ?? this.getCurrency();
        let form = {
            paymentId: paymentData?._id ?? null,
            note: ''
        };

        this.setState({ form, currency })
    }


    get = () => {

    }
    getPaymentData = () => {
        const paymentId = this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/payments/detail-info/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const payment = result ?? null;
                if (!payment || payment?.currentStatus?.status?.key === 'UNPAID') {
                    this.onClose();
                    return;
                }
                this.setState({ paymentData: payment }, () => {
                    this.setInitialData();
                })
            })
        } else {
            this.onClose();
        }
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }
    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }
    }


    getPreviewData = () => {
        const DEFAULT_VALUE = 'N/A'.translate(this.props.lang)

        const paymentData = this.state.paymentData;

        if (!paymentData) {
            return null;
        }
        let patientIds = [];
        if (paymentData?.patientData?._id) patientIds.push(paymentData.patientData._id);
        if (paymentData?.patientData?.parents?.length) {
            paymentData.patientData.parents.forEach(parent => {
                if (parent?._id) patientIds.push(parent._id);
            });
        }
        const isPatient = patientIds.includes(this.props.uData?._id);
        const caseData = paymentData?.caseData?._id ? paymentData?.caseData : null;
        const clinicInfo = paymentData?.clinicInfo ?? {};
        const patientInfo = paymentData?.patientPreviewInfo ?? {};
        const paymentInfo = paymentData?.currentStatus ?? {};
        const paidOnTs = paymentData?.paymentCompletedTime?.ts ?? paymentInfo?.time?.ts;
        const paidOnDate = paidOnTs ? this.props.getStringDateTs(paidOnTs, this.props.dateFormat) : DEFAULT_VALUE;
        const status = paymentInfo?.status?.key ? getHumanReadableStatus(paymentInfo?.status?.key, this.props.lang) : paymentInfo?.status?.[this.props.lang] ?? DEFAULT_VALUE;
        const paymentMethod = getHumanReadablePaymentMethod(paymentInfo?.paymentMethod?.key, this.props.lang) ?? DEFAULT_VALUE;
        const reference = paymentInfo?.reference ?? DEFAULT_VALUE;

        const questionaryName = caseData?.questionaryName ?? null;
        const doctorName = caseData?.doctorName ?? paymentData?.createdByUser?.name;
        const __visitDate = getTimeForPatient(caseData?.visitDate?.ts, caseData?.visitDate?.endTs, caseData?.visitDate?.hideTimeFromThePatient, caseData?.visitDate?.hideDurationForPatient, this.props.getStringDateTs, this.props.dateFormat, this.props.lang, !isPatient)

        const visitDate = __visitDate ? __visitDate : caseData?.visitDate?.ts ? this.props.getStringDateTs(caseData.visitDate.ts, this.props.dateFormat) : caseData?.visitDate?.se ?? DEFAULT_VALUE;

        const currency = paymentData?.amount?.currency ?? this.getCurrency();
        const amount = paymentData?.amount?.value ?? 0;
        const vatRate = paymentData?.vat?.rate ?? 0;
        let baseAmount = 0, vatAmount = 0, vatPrice, basePrice;
        if (vatRate > 0) {
            baseAmount = amount ? (amount / (1 + Number(vatRate) / 100)).toFixed(2) : 0;
            vatAmount = amount ? (amount - baseAmount).toFixed(2) : 0;
            vatPrice = formatPrice(vatAmount, currency);
            basePrice = formatPrice(baseAmount, currency);
        }
        const refundAmount = paymentData?.amount?.refundAmount ? formatPrice(paymentData?.amount?.refundAmount, currency) : null;
        const refundDateTs = refundAmount && paymentData?.status?.find(s => s.status?.key === 'REFUNDED' || s.status?.key === 'PARTIALLY_REFUNDED')?.time?.ts;
        const refundDate = refundAmount && refundDateTs ? this.props.getStringDateTs(refundDateTs, this.props.dateFormat) : null;

        const price = formatPrice(amount, currency);
        const paymentNumber = paymentData?.paymentNumber;


        let _caseAdditionalInfo = [];
        if (questionaryName) _caseAdditionalInfo.push(questionaryName);
        if (doctorName) _caseAdditionalInfo.push(doctorName);

        const freeCardData = paymentInfo?.paymentMethod?.key === 'freeCard' ? paymentInfo?.freeCardData ?? null : null;

        return {
            clinicInfo,
            patientInfo,
            paidOnDate,
            status,
            paymentMethod,
            reference,
            questionaryName,
            doctorName,
            _caseAdditionalInfo,
            visitDate,
            price,
            basePrice,
            refundAmount,
            refundDate,
            vatPrice,
            paymentNumber,
            freeCardData,
            DEFAULT_VALUE
        };
    }



    render() {
        const isOpen = this.props.isOpen;
        const paymentData = this.state.paymentData;

        if (!paymentData) {
            return null;
        }
        const { clinicInfo, patientInfo, paidOnDate, refundDate, status, paymentMethod, reference, questionaryName, doctorName, _caseAdditionalInfo, visitDate, price, vatPrice, basePrice, refundAmount, paymentNumber, freeCardData, DEFAULT_VALUE } = this.getPreviewData();

        return (
            <>
                <Modal isOpen={isOpen} centered className='preview-payment-modal-wrap' size='lg'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Receipt'.translate(this.props.lang)}
                    </ModalHeader>

                    <ModalBody className='preview-payment-modal-body'>
                        <div className='first-section-wrap'>
                            <div className='clinic-info-data-wrap'>
                                <div className='clinic-logo-wrap'>
                                    <img src={`${API_ENDPOINT}${clinicInfo?.groupLogo}`} />
                                </div>
                                <div className='clinic-info-item'>
                                    {clinicInfo?.clinicName}
                                </div>
                                <div className='clinic-info-item'>
                                    {clinicInfo?.clinicAddress}
                                </div>
                                <div className='clinic-info-item'>
                                    {clinicInfo?.clinicPhone}
                                </div>
                            </div>
                            <div className='payment-dates-wrap'>
                                <div className='payment-paid-date-wrap'>
                                    <span>{'Paid on'.translate(this.props.lang)}:</span> {paidOnDate}
                                </div>
                                {
                                    refundDate ?
                                        <div className='payment-paid-date-wrap'>
                                            <span>{'Refunded on'.translate(this.props.lang)}:</span> {refundDate}
                                        </div>
                                        :
                                        null
                                }
                            </div>
                        </div>
                        <hr />
                        <div className='second-section-wrap'>
                            <div className='payment-info-item'><span>{'Receipt no'.translate(this.props.lang)}:</span> {paymentNumber}</div>
                            <div className='payment-info-item'><span>{'Reference'.translate(this.props.lang)}:</span> {reference}</div>
                            <div className='payment-info-item'><span>{'Payment method'.translate(this.props.lang)}:</span> {paymentMethod}</div>
                            {
                                freeCardData ?
                                    <>
                                        <div className='payment-info-item'><span>{'Free kort number'.translate(this.props.lang)}:</span> {freeCardData?.number || DEFAULT_VALUE}</div>
                                        <div className='payment-info-item'><span>{'Valid from'.translate(this.props.lang)}:</span> {freeCardData?.valid?.from || DEFAULT_VALUE}</div>
                                        <div className='payment-info-item'><span>{'Valid to'.translate(this.props.lang)}:</span> {freeCardData?.valid?.to || DEFAULT_VALUE}</div>
                                        <div className='payment-info-item'><span>{'Issued at'.translate(this.props.lang)}:</span> {freeCardData?.regionData?.name || DEFAULT_VALUE}</div>
                                    </>
                                    :
                                    null
                            }
                            <div className='payment-info-item'>
                                <span>{'Personal information'.translate(this.props.lang)}</span>
                                {
                                    patientInfo?.parents?.length ?
                                        <>
                                            <div>{patientInfo?.socialSecurityNumber}</div>
                                            <div>{patientInfo?.name}</div>
                                            {
                                                patientInfo?.parents?.map((parent, idx) => {
                                                    return (
                                                        <>
                                                            <div><span>{'Vårdnadshavare'.translate(this.props.lang)}</span></div>
                                                            <div>{parent?.socialSecurityNumber}</div>
                                                            {parent?.customId && <div>{parent?.customId}</div>}
                                                            <div>{parent?.name}</div>
                                                            <div>{parent?.address}</div>
                                                            <div>{parent?.phone}</div>
                                                            <div>{parent?.email}</div>
                                                            <br />
                                                        </>
                                                    )
                                                })
                                            }
                                        </>
                                        :
                                        <>
                                            <div>{patientInfo?.socialSecurityNumber}</div>
                                            {patientInfo?.customId && <div>{patientInfo?.customId}</div>}
                                            <div>{patientInfo?.name}</div>
                                            <div>{patientInfo?.address}</div>
                                            <div>{patientInfo?.phone}</div>
                                            <div>{patientInfo?.email}</div>
                                        </>
                                }
                            </div>
                            <div className='payment-info-item' style={{ marginTop: 30 }}><span>{'Specification'.translate(this.props.lang)}</span></div>

                        </div>

                        <hr style={{ marginTop: 5 }} />
                        <div className='third-section-wrap'>
                            <div className='case-data-wrap'>
                                <div className='payment-info-item'>{_caseAdditionalInfo.join(', ')}</div>
                                <div className='payment-info-item'><span>{'Visit date'.translate(this.props.lang)}:</span> {visitDate}</div>

                            </div>
                            <div className='price-data-wrap'>
                                {
                                    basePrice ?
                                        <>
                                            <div className='payment-info-item'><span>{'Price'.translate(this.props.lang)}:</span> {basePrice}</div>
                                            <div className='payment-info-item'><span>{'Vat'.translate(this.props.lang)}:</span> {vatPrice}</div>
                                            <div className='payment-info-item'><span>{'Total'.translate(this.props.lang)}:</span> {price}</div>
                                        </>
                                        :
                                        <div className='payment-info-item'><span>{'Total'.translate(this.props.lang)}:</span> {price}</div>
                                }
                                {
                                    refundAmount ?
                                        <div className='payment-info-item'><span>{'Refunded'.translate(this.props.lang)}:</span> {refundAmount}</div>
                                        :
                                        null
                                }
                            </div>
                        </div>


                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>
                        <Button disabled={!paymentData._id || this.props.loadingPdf} className='black-button' color="primary" onClick={() => this.props.getPaymentPdf(paymentData._id)}> {'Save as pdf'.translate(this.props.lang)} </Button>

                        <Button style={{ minWidth: 100 }} color="primary" onClick={() => this.onClose()}>{'Close'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>

                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}

            </>
        );
    }
}


export default PreviewPayment;